module.exports = __webpack_public_path__ + "4409f7d4.svg";